__turbopack_context__.v({
  "badge": "NotificationsBell-module__deqswW__badge",
  "bell": "NotificationsBell-module__deqswW__bell",
  "dropdown": "NotificationsBell-module__deqswW__dropdown",
  "empty": "NotificationsBell-module__deqswW__empty",
  "icon": "NotificationsBell-module__deqswW__icon",
  "item": "NotificationsBell-module__deqswW__item",
  "itemUnread": "NotificationsBell-module__deqswW__itemUnread",
  "list": "NotificationsBell-module__deqswW__list",
  "wrapper": "NotificationsBell-module__deqswW__wrapper",
});
